/**
 * @typedef	{{disabled?: boolean; isGettingData?:boolean; onSubmit: (event: React.ChangeEvent<HTMLInputElement>)=> Promise<void>}} Props
 */

import { translate } from '../../Internationalization';
import FieldRadioGroup from '../../../shared/Forms/Fields/FieldRadioGroup';
import React from 'react';
import Loading from '../../../shared/Loading';

const label = 'global.offers.vendor_exclusivity.radio_labels';
const title = translate('global.offers.vendor_exclusivity.label');

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function VendorExclusivityRadio(props) {
	if (props.isGettingData) {
		return (
			<React.Fragment>
				<span className="input-label">{title}</span>
				<div className="w-fit -ml-4 -scale-50 [&>div]:p-0">
					<Loading />
				</div>
			</React.Fragment>
		);
	}

	return (
		<FieldRadioGroup
			disabled={props.disabled}
			name="exclusivity"
			onClick={props.onSubmit}
			title={title}
			values={[true, false].map((value) => [
				`${value}`,
				translate(`${label}.${value ? 'yes' : 'no'}`),
			])}
		/>
	);
}
